import { Pipe, PipeTransform } from '@angular/core';
import { ThirdParty } from '../interfaces/thirdParty';

@Pipe({
    name: 'filterThirdParties',
    pure: false

})
export class filterThirdPartiesPipe implements PipeTransform {
    transform(data: ThirdParty[], filter: string): ThirdParty[] {
        if (!data || !data.length) return [];
        if (!filter) return data;
        return data.filter(thirdParty => {
            const includeName = thirdParty && thirdParty.name && thirdParty.name.toLowerCase().includes(filter.toLowerCase());
            const includeDocument = thirdParty && thirdParty.document && thirdParty.document.includes(filter);
            return includeName || includeDocument;
        });
    }
}